import { WritableAtom, useAtom } from 'jotai'
import { PropsWithChildren, useCallback, useEffect, useState } from 'react'

import { sendEventLog } from '@/features/log/log.fn'

import * as styles from './tooltip.css'

type TooltipLayout = {
  bubbleOffsetY?: string // 말풍선 자체의 세로 위치 오프셋
  bubbleOffsetX?: string // 말풍선 자체의 가로 위치 오프셋
  arrowOffsetX?: string // 화살표의 가로 위치 오프셋
  arrowOffsetY?: string // 화살표의 세로 위치 오프셋
  arrowDirection?: string // 화살표 방향
}

type SkipOption = 'logbox' | 'mixpanel'

interface TooltipProps extends PropsWithChildren {
  storageKey: WritableAtom<any, [any], void>
  content: string
  layout?: TooltipLayout
  viewActionId?: string
  viewActionSkipOptions?: SkipOption | SkipOption[]
  clickActionId?: string
}

function Tooltip(props: TooltipProps) {
  const { storageKey, content, layout, viewActionId, viewActionSkipOptions, clickActionId, children } = props
  const [tooltipClickedStorageValue, setTooltipClickedStorageValue] = useAtom(storageKey)
  const [visible, setVisible] = useState(false)
  const [isHiding, setIsHiding] = useState(false)

  const handleClick = useCallback(() => {
    setIsHiding(true)
    setTooltipClickedStorageValue(true)
    if (clickActionId) sendEventLog(clickActionId)
  }, [clickActionId, setTooltipClickedStorageValue])

  useEffect(() => {
    if (tooltipClickedStorageValue) {
      setTimeout(() => setVisible(false), 200)
    } else {
      setTimeout(() => setVisible(true), 200)
    }
  }, [tooltipClickedStorageValue])

  useEffect(() => {
    if (visible && viewActionId) {
      sendEventLog(viewActionId, undefined, undefined, viewActionSkipOptions)
    }
  }, [visible, viewActionId, viewActionSkipOptions])

  return (
    <>
      {children}
      {visible && (
        <button
          className={`${styles.tooltip} ${visible ? 'visible' : ''} ${isHiding ? 'hidden' : ''}`}
          style={{ left: layout?.bubbleOffsetX, top: layout?.bubbleOffsetY }}
          onClick={handleClick}
        >
          {content}
          <span
            className={`${styles.tooltip_arr} ${layout?.arrowDirection === 'BOTTOM' ? 'bottom' : 'up'}`}
            style={{
              left: layout?.arrowOffsetX,
              bottom: layout?.arrowOffsetY,
              top: layout?.arrowOffsetY ? 'unset' : '-10px',
            }}
          />
        </button>
      )}
    </>
  )
}

export default Tooltip
